import { useQuery } from 'data-fetching-client';
import { GET_EXTERNAL_OPTIONS_BY_IDS } from 'flow-doctor-lib/queries/CrmObjectQueries';
import { GET_LEGACY_REFERENCE_LABELS_BY_IDS } from 'flow-doctor-lib/queries/LegacyReferenceResolverQueries';
import { useMemo } from 'react';
const useResolveReferenceType = ({
  portalId,
  referenceType,
  ids: rawOptions,
  objectTypeId
}, {
  skip
} = {}) => {
  const {
    data: externalOptionsData,
    loading: externalOptionsLoading,
    error: externalOptionsError
  } = useQuery(GET_EXTERNAL_OPTIONS_BY_IDS, {
    variables: {
      portalId,
      referenceType,
      ids: rawOptions,
      objectTypeId
    },
    skip
  });
  const {
    data: legacyReferenceLabelsData,
    loading: loadingLegacyReferenceLabels,
    error: errorLegacyReferenceLabels
  } = useQuery(GET_LEGACY_REFERENCE_LABELS_BY_IDS, {
    variables: {
      portalId,
      referenceType,
      ids: rawOptions
    },
    skip: skip || !externalOptionsError
  });
  const mergedReferenceLabels = useMemo(() => {
    let externalOptionsLabelMap = {};
    if (externalOptionsData) {
      externalOptionsLabelMap = externalOptionsData.externalOptionsByIds.reduce((acc, option) => Object.assign({}, acc, {
        [option.id]: option.label
      }), {});
    }
    return Object.assign({}, externalOptionsLabelMap, legacyReferenceLabelsData && legacyReferenceLabelsData.legacyReferenceLabelsByIds);
  }, [externalOptionsData, legacyReferenceLabelsData]);
  return {
    data: mergedReferenceLabels,
    loading: externalOptionsLoading || loadingLegacyReferenceLabels,
    error: externalOptionsError && errorLegacyReferenceLabels
  };
};
export default useResolveReferenceType;